import "./EtudiantDasbord.css";
import React from "react";
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import htmlImg from '../../../Assets/caphtml.JPG'
import { BiTimeFive } from "react-icons/bi";
import { IoMdStar } from "react-icons/io";
import { CgSignal } from "react-icons/cg";
import { BsFillBarChartFill } from "react-icons/bs";
import { AiOutlineDownSquare } from "react-icons/ai";
import prof1 from '../../../Assets/prof.png';
import prof from '../../../Assets/avatar.png';




function EtudiantDasbord() {
  return (


    <div className="etudiant-dasbord">
      <div class="d-flex flex-column   bd-highlight container-1-profil" >
        <div className="d-flex p-2 div-prof1il-1" ></div>
        <div className="d-flex p-2 div-prof1il-2">
        </div>
        <div class="d-flex justify-content-center bd-highlight im-prof-bi p-4 mb-3">
          <div class="p2 bd-highlight img  "> <img width='100px' height='100px' src={prof} /></div>
          <div class="p2 bd-highlight nom  ">   <span className="not" >sina ray</span> <BsFillBarChartFill className="bsbi" /> <br />
          <Form.Text  smuted> @Sina_ray   </Form.Text>
          </div>
          
          <div class="ms-auto nom  ai bd-highlight">      <Button variant="warning">mettre a jour son profile</Button></div>
        </div>

      </div>

      <Nav>
        <Nav.Item>
          <Nav.Link eventKey="link-1">All cours</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="link-2">cours</Nav.Link>
        </Nav.Item>

      </Nav>

      {/* ************** composant cart- ********** */}

      <Card style={{ width: '19rem' }}>
        <Card.Img style={{ width: '19 rem', height: '10rem' }} variant="top" src={htmlImg} />
        <Card.Text className=" pt-2 px-4">
          <h6>Révolutionnez la façon dont vous construisez le Web</h6>

          <div class="d-flex bd-highlight">
            <div class="  "><BiTimeFive /> </div>
            <div class=" mx-1">1h 46m </div>
            <div class="  mx-1">  <CgSignal /></div>
            <div class=" flex-fill ">  Intermédiaire</div>
          </div>
          <div className="not-cours d-flex align-items-center mt-4">
            <Form.Text className="not" smuted>
              <IoMdStar />
              <IoMdStar />
              <IoMdStar />
              <IoMdStar />
              <span>5.5 (18)  </span>
            </Form.Text>

          </div>

        </Card.Text>
        <hr />
        <div className="head-cart pt-2 px-4">
          <div class="d-flex bd-highlight im-prof mb-3">
            <div class="p2 bd-highlight im  "> <img width='25px' height='25px' src={prof1} /></div>
            <div class="p2 bd-highlight  mx-2">    Sina Ray</div>
            <div class="ms-auto  ai bd-highlight"><AiOutlineDownSquare /></div>
          </div>
        </div>

      </Card >
    </div >
  );
};

export default EtudiantDasbord;
